module.exports = (__webpack_require__(929))("./src/index.js");